/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * External dependencies
 */
import { useGlobalIsKeyPressed } from '@googleforcreators/design-system';
/**
 * Internal dependencies
 */
import normalizeRotationDegrees from '../utils/normalizeRotationDegrees';

function useRotate({
  onGroupEventStart,
  setTransformStyle,
  onGroupEventEnd,
  targetList,
  frames,
}) {
  // ⇧ key rotates the element 30 degrees at a time
  const throttleRotation = useGlobalIsKeyPressed('shift');

  const onRotateGroupStart = ({ events }) => {
    onGroupEventStart({ events, isRotate: true });
  };
  const onRotateGroup = ({ events }) => {
    events.forEach(({ target, beforeRotate, drag }, i) => {
      const sFrame = frames[i];
      const { element } = targetList[i];
      sFrame.rotate = normalizeRotationDegrees(beforeRotate);
      sFrame.translate = drag.beforeTranslate;
      setTransformStyle(element, target, sFrame);
    });
  };
  const onRotateGroupEnd = ({ targets }) => {
    onGroupEventEnd({ targets, isRotate: true });
  };
  return {
    onRotateGroup,
    onRotateGroupEnd,
    onRotateGroupStart,
    throttleRotate: throttleRotation ? 30 : 0,
  };
}

export default useRotate;
